module.exports = __webpack_public_path__ + "guanao-pc/static/media/13305185550.9f23910b.png";